import { render, staticRenderFns } from "./gl-info-block.vue?vue&type=template&id=0a23c224&"
import script from "./gl-info-block.vue?vue&type=script&lang=js&"
export * from "./gl-info-block.vue?vue&type=script&lang=js&"
import style0 from "./gl-info-block.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports